module.exports = __webpack_public_path__ + "files/0f175e1c143c710fa3a47ea4fcc5219b.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-3.png
// module id = 1396
// module chunks = 59